import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=c9846094&scoped=true&"
import script from "./ConfirmEmail.vue?vue&type=script&lang=ts&"
export * from "./ConfirmEmail.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmEmail.vue?vue&type=style&index=0&id=c9846094&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9846094",
  null
  
)

export default component.exports